export const buttonBase = {
    borderRadius: "7px",
    border: "1px solid #cbd5e1",
    padding: "7px 12px",
    fontSize: "13px",
    cursor: "pointer",
};

export const backButtonStyle = {
    ...buttonBase,
    background: "white",
    color: "#0f172a",
    fontWeight: 800,
    borderColor: "#cbd5e1",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
    transition: "box-shadow 0.16s ease, border-color 0.16s ease, transform 0.16s ease",
};

export const dossierActionButtonStyle = {
    ...buttonBase,
    minHeight: "38px",
    padding: "9px 14px",
    borderRadius: "8px",
    fontWeight: 900,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
};

export const shortcutPillStyle = {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "999px",
    padding: "2px 7px",
    background: "rgba(255, 255, 255, 0.16)",
    border: "1px solid rgba(255, 255, 255, 0.22)",
    fontSize: "11px",
    fontWeight: 800,
};

export const thStyle = {
    padding: "9px",
    borderBottom: "1px solid #cbd5e1",
    textAlign: "left",
    fontSize: "12px",
    color: "#475569",
    whiteSpace: "nowrap",
};

export const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #e2e8f0",
    verticalAlign: "top",
    fontSize: "13px",
};

export const controleTabsRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    width: "100%",
    flexWrap: "wrap",
};

export const iconButtonStyle = {
    width: "28px",
    height: "28px",
    border: "1px solid #cbd5e1",
    borderRadius: "7px",
    background: "white",
    color: "#334155",
    cursor: "pointer",
    fontSize: "16px",
    lineHeight: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
};

export const controleContextMenuStyle = {
    position: "fixed",
    zIndex: 1050,
    minWidth: "168px",
    padding: "6px",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    background: "white",
    boxShadow: "0 16px 38px rgba(15, 23, 42, 0.22)",
};

export const controleContextMenuDangerButtonStyle = {
    width: "100%",
    border: 0,
    borderRadius: "6px",
    padding: "9px 10px",
    background: "transparent",
    color: "#b91c1c",
    cursor: "pointer",
    textAlign: "left",
    fontSize: "13px",
    fontWeight: 850,
};

export const controleModalOverlayStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 1100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    background: "rgba(15, 23, 42, 0.42)",
};

export const controleModalStyle = {
    width: "min(460px, 100%)",
    display: "grid",
    gap: "16px",
    padding: "20px",
    borderRadius: "8px",
    background: "white",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.26)",
};

export const modalCloseButtonStyle = {
    width: "30px",
    height: "30px",
    border: "1px solid #e2e8f0",
    borderRadius: "999px",
    background: "#f8fafc",
    color: "#475569",
    cursor: "pointer",
    fontSize: "18px",
    lineHeight: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

export const ehpadOptionStyle = {
    width: "100%",
    border: 0,
    background: "white",
    textAlign: "left",
    padding: "9px 11px",
    cursor: "pointer",
    color: "#0f172a",
    fontSize: "13px",
};
